<template>
  <div>
    <div v-if="errors" class="alert alert-danger" role="alert">
      <ul class="mb-0 list-unstyled" v-for="{ key, messages } in errors" :key="key">
        <li>
          <b>{{ key }}</b>
          <ul class="mb-0" v-for="message in messages" :key="message">
            <li>{{ message }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//  {
//    "title": "One or more validation errors occurred.",
//    "status": 400,
//    "traceId": "|493b70a-4f92069b4f92f948.",
//    "errors":{
//      "Username": ["The Username field is required."]
//    }
//  }
//

export default {
  props: {
    error: Error,
  },
  computed: {
    errors() {
      if (!this.error) return null;
      if (!this.error.response) return null;
      if (!this.error.response.data) return null;
      if (!this.error.response.data.errors) return null;

      var errors = this.error.response.data.errors;
      var response = Object.keys(errors).map(key => {
        var messages = errors[key];
        key = key === "_server" ? "Errors" : key;
        return { key, messages };
      });

      return response.length ? response : null;
    },
  },
};
</script>
